const getDefaultCheckerState = () => {
  return {
    allCheckers: [],
  }
}

export default getDefaultCheckerState()
export { getDefaultCheckerState }
